module.exports = __webpack_public_path__ + "img/direcciones.65d8fcc8.jpg";